import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/hooks/useAuth";
import napihamiLogo from "@/assets/napihami_logo.png";
import { AccessDeniedPopup } from "./AccessDeniedPopup";

interface AdminGuardProps {
  children: React.ReactNode;
}

export const AdminGuard = ({ children }: AdminGuardProps) => {
  const navigate = useNavigate();
  const { role, loading } = useAuth();

  useEffect(() => {
    if (!loading) {
      if (!role || role === "guest") {
        navigate("/");
      }
    }
  }, [role, loading, navigate]);

  if (loading) {
    return (
      <div className="flex min-h-screen items-center justify-center">
        <img 
          src={napihamiLogo} 
          alt="NapiHami" 
          className="h-[150px] w-auto animate-slide-down"
        />
      </div>
    );
  }

  if (role !== "admin" && role !== "restaurant" && role !== "menu_manager") {
    return <AccessDeniedPopup redirectTo="/" redirectLabel="Vissza a főoldalra" />;
  }

  return <>{children}</>;
};
